<template>
    <div :class="topFixed?'tou1':'tou'">
        <div class="w1200" style="height:100%">
            <img v-if="topFixed" class="logoImg" src="/static/logo3.png">
            <img v-else class="logoImg" src="/static/logo2.png">
            <div class="tou-xx">
                <span class="tou-a" :class="act=='home'?'active':''" style="" @click="$router.push('/homePage')">首页</span>
                <!-- <span class="tou-a" :class="act=='product'?'active':''" @click="$router.push('/aboutproduct')">产品介绍</span> -->
                <span class="tou-a" :class="act=='product'?'active':''" @click="SelectPro()">产品介绍
                    <div class="sanjiao"></div>
                    <div class="item-menu clear-mr">
                        <ul>
                            <li
                                style="font-size: 16px;"
                                v-for='(item,index) in nav'
                                :class='{active:index == current}'
                                @click='go(index)'
                                :key="index"
                            >{{item}}</li>
                        </ul>
                    </div>
                </span>
                <span class="tou-a" :class="act=='news'?'active':''" @click="$router.push('/newbull')">新闻公告</span>
                <span class="tou-a" :class="act=='help'?'active':''" @click="$router.push('/helpcentre')">帮助中心</span>
                <span class="tou-a" :class="act=='about'?'active':''" @click="$router.push('/aboutus')">关于我们</span>
                <span class="tou-a" :class="act=='join'?'active':''" @click="$router.push('/joinus')">加入我们</span>
                <button class="tuo-anniu" style="margin-left:230px;" @click="$router.push('/login')">登录</button>
                <button class="tuo-anniu" @click="$router.push('/regist')">丨 注册 丨</button>
                <span class="tuo-anniu" @click="zhwy()">中行网银</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
	name: 'gylhead',
	props: {
        act:{
            type:String,
            default:''
        },
	},
	data() {
		return {
            topFixed:false,
            scrollTop:null,
            current:0,//切换标识
            nav:[//菜单
               '金云e诺',
               '中银企E贷',
               '中联保理专区',
            ],
            thememenu:'light',
            showlist:false,
		}
    },
	created(){
        if(this.$store.state.menu.scroll>375){//解决滚动后再点击切换其他tab的bug，且必须写在created里避免闪烁
            this.topFixed = true;
        }else{
            this.topFixed = false;
        }
    },
    mounted(){
        window.addEventListener('scroll',this.handleScroll)
    },
	methods: {
        handleScroll(e){
            this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            this.$store.commit("setScroll",this.scrollTop);
            if(this.$store.state.menu.scroll>375){
                this.topFixed = true;
            }else{
                this.topFixed = false;
            }
        },
        zhwy(){
            window.location.href='https://ebsnew.boc.cn/boccp/login.html?entryType=9';
        },
        go(index){
            if (index === 0) {
                this.$router.push('/aboutproduct');
            } else if (index === 1){
                this.$router.push('/aboutproduct2');
            } else if (index === 2){
                window.open('https://zlyl.baoliyun.com/')
                this.hotPoint()
            }
            this.current = index;
        },
        hotPoint(){
            // let query = {source:'baoli',applicationKernel:window.navigator.appVersion}
            let query = {sourceStr:'保理',applicationKernel:window.navigator.appVersion}

            this.$ajax.login1('/common/common/hotPoint',query).then(data => {
                if (data.status == this.$ajax.HTTP_S) {}
                if(data.status==this.$ajax.HTTP_F) this.$Message.error({content:data.message,closable: true});
            });
        },
        SelectPro(){
            this.showlist=true
        }
	}
}
</script>
<style scoped>
.tou {
  height: 80px;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 1000;
  color: #fff;
  transition: background 1s;
}
.tou1 {
  height: 80px;
  width: 100%;
  background: #fff;
  color: #000;
  position: fixed;
  top: 0;
  z-index: 1000;
  transition: background 1s;
  box-shadow: 0px -14px 50px;
}
.tou1 .tuo-anniu {
  color: #000;
  background: none;
  line-height: 24px;
  font-size: 18px;
  border: none;
}
/* .tou-logo {
	float:left;
	height:.44rem;
}
*/
.logoImg {
  height: 40px;
  width: 150px;
  float: left;
  margin-top: 22px;
}
.tou-a {
  height: 22px;
  font-size: 18px;
  text-align: center;
  text-decoration: none;
  position: relative;
  display: inline-block;
  margin-left: 22px;
}
.tou-a:after {
  content: '';
  position: absolute;
  width: 0%;
  height: 3px;
  bottom: -10px;
  left: 50%;
  background-color: #fff;
  transition: width 0.2s, left 0.2s;
}
.tou1 .tou-a:after {
  background-color: #2f86bf;
}
.tou-a.active.tou-a:after {
  width: 100%;
  left: 0%;
}
.tou-a:hover.tou-a:after {
  width: 100%;
  left: 0%;
}
.tou-xx {
  float: left;
  margin: 26px 0 0 34px;
}
.tou-xx span {
  cursor: pointer;
}
.tuo-anniu {
  color: #fff;
  background: none;
  line-height: 24px;
  font-size: 18px;
  border: none;
  cursor: pointer;
  outline: none;
}
/* .tuo-anniu1 {
	margin-left:0.1rem;
	border:1px solid #D0021B;
	border-radius:10px;
	width:56px;
	color:red;
	background:none;
}
*/
.item-menu {
  width: 110px;
  background-color: white;
  color: black;
  position: absolute;
  border-radius: 4px;
  z-index: 30;
}
.tou-a .item-menu {
  display: none;
}
.tou-a:hover .item-menu {
  display: block;
}
.tou-a .sanjiao {
  display: none;
}
.tou-a:hover .sanjiao {
  display: block;
  background-color: #ffffff;
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  margin: -3px auto -5px;
}
.item-menu ul li {
  margin: 2px auto;
}

.clear-mr {
    left: -20px;
}
.clear-mr ul li {
    margin: 0;
}
.item-menu ul li:hover {
  background-color: #3f70ed;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/inc/component/gyl-head.vue